import { LookupValues } from 'src/utils/types';

export const AUTH_EVENT_NAME = 'zhl.mortgageapplicationcenter.auth';
export const AUTH_EVENT_TYPES = {
    LOGIN: 'login',
    SESSION_REFRESH: 'refresh',
    SESSION_REFRESH_ERROR: 'refresh_error',
    LOGOUT: 'logout',
} as const;

export type AuthEventType = LookupValues<typeof AUTH_EVENT_TYPES>;
